export async function getDictionary(path, locale) {
  try {
    const module = await import(`${path}/${locale}.json`);
    return module.default;
  } catch (e) {
    return null;
  }
}
